const tabs = document.querySelectorAll(".fit-sec__tab");
const contents = document.querySelectorAll(".fit-sec__tab-content-item");
const contentWrapper = document.querySelector(".fit-sec__tab-content");

tabs.forEach((tab, index) => {
  tab.addEventListener("click", () => {
    tabs.forEach(t => t.classList.remove("active"));
    contents.forEach(c => c.classList.remove("active"));

    tab.classList.add("active");
    contents[index].classList.add("active");
  });
});

window.addEventListener("DOMContentLoaded", () => {
  let maxHeight = 0;

  contents.forEach(item => {
    const itemHeight = item.offsetHeight;
    if (itemHeight > maxHeight) {
      maxHeight = itemHeight;
    }
  });

  if (contentWrapper) {
    contentWrapper.style.minHeight = maxHeight + "px";
  }
});
